import {FuelPlacement} from '../types';

export const getMenuAlignment = (align: string): FuelPlacement => {
    switch (align) {
        case 'end':
            return 'bottom-end';
        case 'center':
            return 'bottom';
        default:
            return 'bottom-start';
    }
};
